export default function masks(){
    if(document.querySelector(".phone")){
        $(document).ready(function(){
            $(".phone input").mask("(00) 00000-0000");
            $(".modal-reserv .phone").mask("(00) 00000-0000");
        });
    }
}